var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24Support(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 23.575H22.0501C21.0501 23.575 20.1001 23.9625 19.4001 24.6625L17.2626 26.7751C16.2876 27.7376 14.7001 27.7376 13.7251 26.7751L11.5876 24.6625C10.8876 23.9625 9.92506 23.575 8.93756 23.575H8.00006C5.92506 23.575 4.25006 21.9125 4.25006 19.8625V6.22498C4.25006 4.17498 5.92506 2.51251 8.00006 2.51251H23.0001C25.0751 2.51251 26.7501 4.17498 26.7501 6.22498V19.8625C26.7501 21.9 25.0751 23.575 23.0001 23.575Z",
    stroke: "#101010",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25006 11.45C9.25006 10.2875 10.2001 9.33746 11.3626 9.33746C12.5251 9.33746 13.4751 10.2875 13.4751 11.45C13.4751 13.8 10.1376 14.05 9.40005 16.2875C9.25005 16.75 9.63756 17.2125 10.1251 17.2125H13.4751",
    stroke: "#101010",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5501 17.2V10.0625C20.5501 9.73754 20.3376 9.44996 20.0251 9.36246C19.7126 9.27496 19.3751 9.39996 19.2001 9.67496C18.3001 11.125 17.3251 12.775 16.4751 14.225C16.3376 14.4625 16.3376 14.775 16.4751 15.0125C16.6126 15.25 16.8751 15.3999 17.1626 15.3999H21.7501",
    stroke: "#101010",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Support);
export default __webpack_public_path__ + "static/media/24-support.d1b41351f6219a98403691c5c011326e.svg";
export { ForwardRef as ReactComponent };